'use client'

import type { SharedUITextInputProps } from '../../_shared/SharedUITextInput.client'
import { TextInput } from '../text/TextInput.client'

export const DIGITS_ONLY_REGEX = /[^\d]/gi
export const DIGITS_WITH_FLOAT_REGEX = /[^\d.,]/gi

type NumberInputOwnProps = StrictOmit<
  SharedUITextInputProps<'required' | 'asyncValidate'>,
  'placeholder'
> & {
  placeholder?: string
  isDisabled?: boolean
  floatAllowed?: boolean
  autoFocus?: boolean
}

/**
 * @example
 * ```tsx
 * <Form.Input.Number
 *  name="number"
 *  label="..."
 *  required
 * />
 * ```
 */
export function NumberInput({
  name,
  label,
  required,
  className,
  placeholder,
  isDisabled = false,
  floatAllowed = false,
  autoFocus = false,
  ...rules
}: NumberInputOwnProps) {
  const regEx = floatAllowed ? DIGITS_WITH_FLOAT_REGEX : DIGITS_ONLY_REGEX
  const inputMode = floatAllowed ? 'decimal' : 'numeric'

  return (
    <TextInput
      {...rules}
      name={name}
      required={required}
      label={label}
      className={className}
      placeholder={placeholder || ''}
      isDisabled={isDisabled}
      autoFocus={autoFocus}
      inputMode={inputMode}
      onChange={(e) => {
        e.target.value = e.target.value.replace(regEx, '')
      }}
      onBlur={(e) => {
        if (!e.target.value) {
          e.target.value = '0'
        }
      }}
    />
  )
}
